<template>
  <div class="report-format-container">
    <h1>Report Format</h1>
    <p>Coming soon...</p>
  </div>
</template>

<script>
export default {
  name: 'ReportFormat'
}
</script>

<style scoped>
.report-format-container {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

h1 {
  font-size: 28px;
  color: #374957;
  margin-bottom: 12px;
}

p {
  font-size: 16px;
  color: #7C8DA1;
}
</style>
